export default {
	state: {
		shops: [
			{
				id: '001',
				street: ' Историческая, д. 175',
				point: 'АШАН'
			},
			{
				id: '002',
				street: 'Нефтяников шоссе, д. 42',
				point: 'АШАН'
			},
			{
				id: '003',
				street: 'Восточный Обход, д. 19',
				point: 'ЛЕНТА'
			},
			{
				id: '004',
				street: 'Западный Обход, д. 29',
				point: 'ЛЕНТА'
			},
			{
				id: '005',
				street: 'Российская, д. 257',
				point: 'ЛЕНТА'
			},
			{
				id: '006',
				street: 'Крылатая д. 2',
				point: 'О`КЕЙ'
			},
			{
				id: '007',
				street: 'Мачуги д. 2 лит. А',
				point: 'О`КЕЙ'
			},
			{
				id: '008',
				street: 'Минская д. 120/8 лит. А',
				point: 'О`КЕЙ'
			},
			{
				id: '009',
				street: 'Уральская д. 98/11',
				point: 'О`КЕЙ'
			}

		]
	},
	mutations: {},
	actions: {},

	getters: {
		getKrasnodar (state) {
			return state.shops
		}
	}
}